import { useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';
import { useCallback } from 'react';

import { CachedBonuses, Reaction } from '../../../../../../types/bonus';
import { updateCachedReactions } from '../../../cache/mutators/bonus';
import { QueryKey } from '../../../hooks/types';
import { useFindBonus } from './use-find-bonus';

export const useAddReactionToBonus = () => {
	const queryClient = useQueryClient();
	const findBonus = useFindBonus();

	return useCallback(
		(id: string, reaction: Reaction) => {
			const bonus = findBonus(id);

			if (!bonus) {
				return;
			}

			const newReactions = produce(bonus.reactions ?? [], (draft) => {
				draft.push(reaction);
			});

			queryClient.setQueriesData<CachedBonuses>([QueryKey.BonusesInfinite], (cached) => updateCachedReactions(id, newReactions, cached));
		},
		[findBonus, queryClient]
	);
};
